import React, { useContext } from "react";

import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import { EnquiryContext } from "venuescanner-js/react/components/Inbox/context/EnquiryContext";

import LeadInstructionsThumbnail from "venuescanner-js/react/components/Inbox/components/Leads/LeadInstructionsThumbnail";

export const LeadsPanel = () => {
  const { indicators } = useContext(EnquiryContext);
  const { isMobileDevice } = useContext(ViewContext);

  return (
    <div className="leads-panel">
      {indicators.leads?.received ? (
        <>
          <h2 className="leads-panel__icon">&#128079;</h2>
          <p className="leads-panel__copy">
            MatchLeads are events that are well matched to your venue. If your
            venue is available to host the event, click Interested.
          </p>
          {!isMobileDevice && <LeadInstructionsThumbnail />}
        </>
      ) : (
        <>
          <h2>&#128269;</h2>
          <p className="leads-panel__copy">
            We’ve sent your event details to a selection of highly rated venues
            to confirm their availability to host you. We'll let you know as
            soon as we hear from them.
            <br />
            <br />
            If you have any questions feel free to contact our team.
          </p>
          <button
            className="leads-panel__button button button--light"
            onClick={() => Intercom("show")}
          >
            Contact Team
          </button>
        </>
      )}
    </div>
  );
};

export default LeadsPanel;
